import { Environments } from '@product/cabify-environments';
import { config } from 'config';

export function handleError(originalError: unknown): void {
  let error: Error;

  if (originalError instanceof Error) {
    error = originalError;
  } else {
    error = new Error('An unknown error occurred.');
  }

  if (config.appEnv !== Environments.PRODUCTION) {
    console.error(error.message);
  } else {
    /**
     * TODO: Add error reporting service
     */
  }
}

export const handleAsync = (asyncFn: () => Promise<unknown>): void => {
  // Initiate the promise but don't wait for it
  asyncFn()?.catch(handleError);
};
